"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _AuthProvider = _interopRequireDefault(require("../../providers/AuthProvider"));
var _AuthMachine = _interopRequireDefault(require("../../machines/AuthMachine"));
var _Loading = _interopRequireDefault(require("../Loading"));
var _Button = _interopRequireDefault(require("../Button"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _naniClub = require("../../services/naniClub");
var _constants = require("../../constants");
var _NaniClubRedirect = require("./NaniClubRedirect.style");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Nani Club 登入落點頁
 *
 * 這頁只負責依登入狀態決定要去哪，以及在失敗時把訊息顯示出來。
 */
const NaniClubRedirect = () => {
  const {
    useAuthState
  } = _AuthProvider.default;
  const {
    state: AuthStates
  } = _AuthMachine.default;
  const history = (0, _reactRouterDom.useHistory)();
  const authState = useAuthState();
  (0, _react.useEffect)(() => {
    if (authState.matches(AuthStates.LoginDone)) {
      history.replace("/");
      return;
    }
    // 新會員要先在 Login 頁面選學制
    if (authState.matches(AuthStates.ReadySettingEducation)) {
      history.replace(_constants.LOGIN_PATH);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authState.value]);
  if (!authState.matches(AuthStates.Idle)) {
    return /*#__PURE__*/_react.default.createElement(_NaniClubRedirect.UiNaniClubRedirect, null, /*#__PURE__*/_react.default.createElement(_Loading.default, null));
  }
  return /*#__PURE__*/_react.default.createElement(_NaniClubRedirect.UiNaniClubRedirect, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "iconBox"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "cancel"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "title"
  }, "\u767B\u5165\u672A\u5B8C\u6210"), /*#__PURE__*/_react.default.createElement("div", {
    className: "message"
  }, authState.context.error || "登入失敗，請重新登入。"), /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "blue",
    onClick: () => (0, _naniClub.redirectToLogin)(history)
  }, "\u91CD\u65B0\u767B\u5165")));
};
var _default = exports.default = NaniClubRedirect;